import { Injectable, Inject } from '@angular/core';
import { HISTORY_SIZE_LIMIT } from './history_size_limit';
import { Observable, Subject } from 'rxjs';
import { Map as ImmutableMap } from 'immutable';
import { HistoryManagerServiceInterface } from './history-manager.service.interface';

export type HistoryData = ImmutableMap<any, any>;

@Injectable({
  providedIn: 'root'
})
export class HistoryManagerService implements HistoryManagerServiceInterface {
  private changeEvent = new Subject<HistoryData>();
  // private docLoadedEvent = new Subject<boolean>();
  get onChange(): Observable<HistoryData> {
    return this.changeEvent.asObservable();
  }
  tracks: HistoryData[] = [];
  cursor: number = -1;
  get currentData(): HistoryData {
    return this.tracks[this.cursor];
  }
  get undoable(): boolean {
    return this.cursor > -1;
  }
  get redoable(): boolean {
    return this.cursor < this.tracks.length - 1;
  }
  constructor(@Inject(HISTORY_SIZE_LIMIT) private sizeLimit = 10) {}

  undo(steps: number = 1) {
    while (steps > 0 && this.undoable) {
      this.cursor--;
      steps--;
    }
  }
  redo(steps: number = 1) {
    while (steps > 0 && this.redoable) {
      this.cursor++;
      steps--;
    }
  }
  push(data: HistoryData) {
    if (this.tracks[this.cursor] !== data) {
      this.tracks.splice(this.cursor + 1, this.tracks.length);
      this.tracks.push(data);
      this.cursor++;
      this.rotate();
      this.changeEvent.next(this.currentData);
    } else {
      console.info(`Duplicate entry is not allowed.`);
    }
  }
  empty() {
    this.cursor = -1;
    this.tracks = [];
    this.changeEvent.next(this.currentData);
  }

  private rotate() {
    let diff = this.tracks.length - this.sizeLimit;
    if (diff > 0) {
      this.tracks.splice(0, diff);
      this.cursor -= diff;
      console.info(
        `History size has grown out of its limit size. has rotated ${diff} items.`
      );
    }
  }
}
